module.exports = __webpack_public_path__ + "static/media/spotify-icon.a253d61e.png";